/**
 * Created by Laith Abu Zainih on 12/6/2017.
 */

(function (app) {

    jobManifestController.$inject = ["$scope", "modalData", "withdraw", "openEditInterviewModal"];
    function jobManifestController($scope, modalData, withdraw, openEditInterviewModal) {

        var PAGINATION = {
            LIMIT: 8,
            OFFSET: 0
        },
        initialPage = 10,
        maxBottomOffsetToLoadData = 300,
        allRecordsLoaded = false,
        paginateTracker = angular.copy(PAGINATION);

        $scope.filters = {};
        $scope.interviewType = modalData.interviewType;

        var fullOpendaysSets = [];

        $scope.onViewChange = function (view) {
            if (view !== $scope.view) {
                $scope.view = view;

                if (view === $scope.VIEWS.OPENDAY) {
                    applyOpendaysSetsFilters();
                } else {
                    resetPaginationAndData();

                    getJobInterviewsSets().then(function () {
                        $scope.$digest();
                    });
                }

            }
        };

        $scope.onInterviewerFilterChange = function () {

            if ($scope.view === $scope.VIEWS.INTERVIEW) {
                resetPaginationAndData();

                getJobInterviewsSets().then(function () {
                    $scope.$digest();
                });
            }
            else {
                applyOpendaysSetsFilters();
            }

        };

        $scope.onAppStatusFilterChange = function () {

            if ($scope.view === $scope.VIEWS.INTERVIEW) {
                resetPaginationAndData();

                getJobInterviewsSets().then(function () {
                    $scope.$digest();
                });
            }
            else {
                applyOpendaysSetsFilters();
            }
        };

        function applyOpendaysSetsFilters() {

            var opendaysSets = angular.copy(fullOpendaysSets);

            if ($scope.filters.interviewer_id || $scope.filters.status) {

                $scope.opendaysSets = [];

                for (var i in opendaysSets) {

                    var interviewers = opendaysSets[i].interviewers;

                    // filter by interviewer_id
                    if (!$scope.filters.interviewer_id || interviewers.findIndex(function (interviewer) {return interviewer.user_id == $scope.filters.interviewer_id}) > -1) {
                         $scope.opendaysSets.push(opendaysSets[i]);
                    }

                    //filter by applications status
                    if ($scope.filters.status) {
                        $scope.opendaysSets[$scope.opendaysSets.length - 1].applications = $scope.opendaysSets[$scope.opendaysSets.length - 1].applications.filter(function (app) {
                            return app.status == $scope.filters.status;
                        });
                    }

                    if (!$scope.opendaysSets[$scope.opendaysSets.length - 1].applications.length) {
                        $scope.opendaysSets.pop();
                    }

                }

            } else {
                $scope.opendaysSets = opendaysSets;
            }
        }

        $scope.editInterviewSet = function (set) {
            openEditInterviewModal(set);
            $scope.close();
        };

        $scope.withdraw = function (app) {

            if (!app.withdrawing) {

                app.withdrawing = true;

                InterviewV2API.withdrawInterview(modalData.brandId, modalData.jobId, [app.application_id], $scope.interviewType)
                    .then(function (res) {

                        if (res && res.succeded && res.succeded.length && res.succeded.indexOf(parseInt(app.application_id)) > -1) {
                            withdraw(app.application_id);
                            app.status = $scope.INTERVIEW_STATUSES.WITHDRAWN;
                            $scope.$digest();
                        }
                        else {
                            delete app.withdrawing;
                            $scope.$digest();
                        }

                    }, function (err) {

                        delete app.withdrawing;
                        $scope.$digest();
                    });
            }
        };

        function resetPaginationAndData () {
            $scope.interviewSets = [];
            paginateTracker = angular.copy(PAGINATION);
        }

        function getJobInterviewsSets(initialPage) {

            var defer = $q.defer();

            $scope.loading = true;

            var interviewerIds = [];

            if ($scope.filters.interviewer_id) {
                interviewerIds = [$scope.filters.interviewer_id];
            }

            var limit = initialPage || paginateTracker.LIMIT;

            var types = [$scope.interviewType];
            if ($scope.interviewType === 'INVITE') {
                types = types.concat(["JOB", "AQAAF"]);
            }

            InterviewV2API.getJobInterviewSets(modalData.brandId, modalData.jobId, interviewerIds,
                $scope.filters.status, types, paginateTracker.OFFSET, limit)
                    .then(function (data) {

                        for (var i in data.interview_sets) {
                            var existingSet = _.find($scope.interviewSets, function (item) {
                                return item.id === data.interview_sets[i].id;
                            });

                            for (var j in data.interview_sets[i].applications) {
                                var item = data.interview_sets[i].applications[j];
                                item.user.full_name = item.user.first_name + ' ' + item.user.last_name;
                            }

                            if (!existingSet) {
                                $scope.interviewSets.push(data.interview_sets[i]);
                            }
                        }

                        paginateTracker.OFFSET += limit;

                        allRecordsLoaded = data.interview_sets.length < limit;

                        defer.resolve(data.interview_sets);

                        $scope.loading = false;

                    });

            return defer.promise;
        }

        (function () {

            resetPaginationAndData();

            getJobInterviewsSets(initialPage)
                .then(function () {
                    // WHAT IS THIS :)
                    $scope.$digest();
                });

            BrandAPI.getBrandInterviewers(modalData.brandId, true)
                .then(function (data) {
                    $scope.interviewers = data.users;
                    $scope.$digest();
                });

            InterviewV2API.getJobInterviewSetsCounts(modalData.brandId, modalData.jobId)
                .then(function (data) {
                    if (modalData.interviewType === 'SECOND_INVITE') {
                        $scope.interviewSetsCount = data.applications.SECOND_INVITE;
                    } else if (modalData.interviewType === 'PHONE') {
                        $scope.interviewSetsCount = data.applications.PHONE;
                    } else {
                        $scope.interviewSetsCount = data.applications.INVITE;
                    }

                });

            if (modalData.interviewType === 'INVITE') {
                InterviewV2API.getJobInterviewSets(modalData.brandId, modalData.jobId, [], '', ["OPEN_DAY"])
                    .then(function (data) {
                        fullOpendaysSets = data.interview_sets;
                        $scope.opendaysSets = fullOpendaysSets;
                        $scope.$digest();
                    });
            }

        })();

        $scope.initScrollEvent = function () {

            setTimeout(function () {

                $('.views').on('scroll views-scroll', function (e) {

                    if (!$scope.loading && !allRecordsLoaded && $scope.view === $scope.VIEWS.INTERVIEW) {

                        var $this = $(this);

                        var scrollValue = $this.scrollTop();
                        var viewportHeight = $this.height();
                        var scrollHeight = $this.find('.interview-sections').height();

                        if (maxBottomOffsetToLoadData >= scrollHeight - (scrollValue + viewportHeight)) {
                            getJobInterviewsSets()
                                .then(function () {
                                    $scope.$digest();
                                });
                        }
                    }
                });
            }, 100);

        };

        $scope.close = function () {
            $('.views').off('scroll views-scroll');
            $scope.$hide();
        };

        $scope.INTERVIEW_STATUSES = {};
        $scope.INTERVIEW_STATUSES.ALL = "";
        $scope.INTERVIEW_STATUSES.CONFIRMED = "CONFIRMED";
        $scope.INTERVIEW_STATUSES.SENT = "SENT";
        $scope.INTERVIEW_STATUSES.DENIED = "DENIED";
        $scope.INTERVIEW_STATUSES.WITHDRAWN = "WITHDRAWN";
        $scope.INTERVIEW_STATUSES.REQUEST_NEW_TIME = "TIME_REQUESTED";


        $scope.VIEWS = {};
        $scope.VIEWS.INTERVIEW = 'INTERVIEW';
        $scope.VIEWS.OPENDAY = 'OPENDAY';

        $scope.view = $scope.VIEWS.INTERVIEW;
    }

    app.controller('jobManifestController', jobManifestController);
})(angular.module('harriApp'));
